import ContentForm from '../../components/ContentForm/ContentForm';

export default function CreateContent() {
  return <ContentForm />;
}
